
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import 'toastr/build/toastr.min.css';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import principalj2t5n from './pages/principalj2t5n/principalj2t5n'
import eventosr413q from './pages/eventosr413q/eventosr413q'
import uniteanosotrosy91yw from './pages/uniteanosotrosy91yw/uniteanosotrosy91yw'
import ubicaciones6ua1kh from './pages/ubicaciones6ua1kh/ubicaciones6ua1kh'
import menuppojl from './pages/menuppojl/menuppojl'
import carritodecomprasg8pi6 from './pages/carritodecomprasg8pi6/carritodecomprasg8pi6'
import pagoexitosofok5d from './pages/pagoexitosofok5d/pagoexitosofok5d'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/" component={principalj2t5n} />
			<Route exact path="/eventos" component={eventosr413q} />
			<Route exact path="/unite" component={uniteanosotrosy91yw} />
			<Route exact path="/ubicaciones" component={ubicaciones6ua1kh} />
			<Route exact path="/menu" component={menuppojl} />
			<Route exact path="/carrito" component={carritodecomprasg8pi6} />
			<Route exact path="/exitoso" component={pagoexitosofok5d} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

